<template>
  <div>
    <div class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
    </div>
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.spacetype}}</div>
      <input type="text" class="input" v-model="controlInfo.spacetype">
    </div>
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.spacetype_subtype}}</div>
      <select class="input"
        v-model="controlInfo.subtype">
        <option value="0" disabled>0</option>
        <option
          v-for="subtype of $route.params.subtype ? 8 : 0"
          :key="subtype"
          :value="subtype.toString()"
          :readonly="readOnlySubtype(subtype)"
          :disabled="readOnlySubtype(subtype)">{{subtype.toString()}}</option>
      </select>
    </div>
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.spacetype_desc}}</div>
      <input type="text" class="input" v-model="controlInfo.memo">
    </div>
    <!-- change language value -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.language}}</div>
      <select class="input" v-model="langs.current">
        <option
          v-for="lang in usableList"
          :key="lang.c"
          :value="lang.c"
          :disabled="isNew && lang.c !== langs.default">
          {{ langName(lang.c) }}
        </option>
      </select>
      <p class="mt5 f_light colorGrey">{{langMessage}}</p>
    </div>
    <!-- //change language value -->
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'controlInfo',
    'subtypeNames',
    'langs'
  ],
  computed: {
    isNew () {
      return this.$route.name === 'controlNewItem'
    },
    usableList () {
      return this.langs.info.filter(x => {
        return this.langs.usable.indexOf(x.c) !== -1
      })
    },
    langMessage () {
      const langs = this.langs
      const current = langs.current
      let message
      if (this.isNew) {
        message = this.locale.page_language_disabled_default_message
      } else {
        if (langs.manual.includes(current)) {
          message = null
        } else {
          message = this.locale.translate_auto_message
        }
      }
      return message
    }
  },
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    langName (c) {
      const code = `lang_${c}`
      const translate = this.langs.manual.includes(c) ? 'translate_manual' : 'translate_auto'
      const isDefault = this.langs.default === c ? `(${this.locale.setting_language_default})` : ''
      return `${this.locale[code]} - ${this.locale[translate]}${isDefault}`
    },
    getSubtype (val) {
      return (val - 1).toString()
    },
    readOnlySubtype (val) {
      const subtype = val.toString()
      const exist = this.subtypeNames.includes(subtype)
      const itself = this.$route.params.subtype === subtype
      return itself || exist
    },
    save () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
.viewType {
  .type {
    display: inline-block;
    vertical-align: middle;
    label {
      display: block;
      padding: 4px;
      border: 1px solid $color-lgrey;
      cursor: pointer;
      &:before {
        content: "";
        display: block;
        width: 32px;
        height: 32px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        opacity: 0.15;
      }
    }
    & + .type {
      margin-left: 5px;
    }
    :checked+label {
      border-color: $color-dark;
      &:before {
        opacity: 0.75;
      }
    }
  }
  [data-type="grid"] label:before {
    background-image: url('~@/assets/img/ico_control_grid.png');
  }
  [data-type="list"] label:before {
    background-image: url('~@/assets/img/ico_control_list.png');
  }
}
</style>
